import queryString from 'query-string';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import ReactPaginate from 'react-paginate';
import { NumberParam, useQueryParam, withDefault, ArrayParam } from 'use-query-params';
import Content from './PartnerShowcaseListingContent';
const scrollToRef = (ref) => {
    if (ref.current != null) {
        window.scrollTo(0, ref.current.offsetTop - 230);
    }
};
const PartnerShowcaseListing = ({ partnerId }) => {
    const [selectedPage = 1, onSelectPage] = useQueryParam('page', withDefault(NumberParam, 1));
    const [selectedFilters] = useQueryParam('topics', withDefault(ArrayParam, []));
    const [data, setData] = useState(null);
    // Serialise for comparison check.
    const selectedFilterJson = JSON.stringify(selectedFilters);
    const myRef = useRef(null);
    const executeScroll = () => scrollToRef(myRef);
    useEffect(() => {
        getData();
        async function getData() {
            const query = {
                page: selectedPage,
                topics: selectedFilters && [...selectedFilters],
            };
            const res = await fetch(`/api/partnershowcase/${partnerId}/load/?${queryString.stringify(query)}`);
            if (!res.ok) {
                return;
            }
            const resData = (await res.json());
            setData(resData);
        }
    }, [selectedFilterJson, selectedPage]);
    if (!data) {
        return null;
    }
    // The number means number of cards per page
    const totalPages = Math.ceil(data.totalResults / 12);
    return (React.createElement(Fragment, null,
        data.items.length > 0 ? (React.createElement("section", { className: `site-wide js-showcase` },
            React.createElement("div", { className: `grid-container grid-container--full vert-margin-50` },
                React.createElement("div", { className: "grid-column" },
                    React.createElement("div", { className: `grid-container grid-container--third` },
                        React.createElement(Content, { items: data.items })))))) : null,
        totalPages > 1 && (React.createElement("section", { className: "pagination" },
            React.createElement(ReactPaginate, { previousLabel: React.createElement("svg", { className: "icon-svg icon-chevron-down" },
                    React.createElement("use", { xlinkHref: "/src/img/svg/icon-chevron-down.svg#icon-chevron-down" })), nextLabel: React.createElement("svg", { className: "icon-svg icon-chevron-down" },
                    React.createElement("use", { xlinkHref: "/src/img/svg/icon-chevron-down.svg#icon-chevron-down" })), breakLabel: "...", breakClassName: "pagination__dots", pageCount: totalPages, marginPagesDisplayed: 2, pageRangeDisplayed: 5, onPageChange: (event) => {
                    onSelectPage(event.selected + 1, 'pushIn');
                    executeScroll();
                }, activeClassName: "pagination--active" })))));
};
export default PartnerShowcaseListing;
